import { lazy, Suspense } from "react";
import TwoFactorVerify from "./TwoFactorVerify";
import SessionsLayout from "./SessionsLayout";

const Signup = lazy(() => import("./Signup"));
const Signin = lazy(() => import("./Signin"));
const Error404 = lazy(() => import("./Error"));
const ForgotPassword = lazy(() => import("./ForgotPassword"));
const Resetpasswordpage = lazy(() => import("./Resetpasswordpage"));
const OAuthCallback = lazy(() => import("./OAuthCallback"));
const GoogleSetup = lazy(() => import("./GoogleSetup"));
const OnboardingLoaderPage= lazy(()=>import ("./OnboardingLoaderPage"))
const OnboardingFullPage = lazy(() => import("../Onboarding/OnboardingPage.jsx"));
const sessionsRoutes = [
  {
    path: "/sessions",
    element: <SessionsLayout />,
    children: [
      {
        path: "signup",
        element: (
          <Suspense>
            <Signup />
          </Suspense>
        ),
      },
      {
        path: "signin",
        element: (
          <Suspense>
            <Signin />
          </Suspense>
        ),
      },
      {
        path: "oauth-callback",
        element: (
          <Suspense>
            <OAuthCallback />
          </Suspense>
        ),
      },
      {
        path: "google-setup",
        element: (
          <Suspense>
            <GoogleSetup />
          </Suspense>
        ),
      },
      {
        path: "forgot-password",
        element: (
          <Suspense>
            <ForgotPassword />
          </Suspense>
        ),
      },
      {
        path: "404",
        element: (
          <Suspense>
            <Error404 />
          </Suspense>
        ),
      },
      {
        path: "reset-password",
        element: (
          <Suspense>
            <Resetpasswordpage />
          </Suspense>
        ),
      },
      {
        path: "verify-2fa",
        element: (
          <Suspense>
            <TwoFactorVerify />
          </Suspense>
        ),
      },
      {
        path: "onboarding",
        element: (
          <Suspense>
            <OnboardingLoaderPage />
          </Suspense>
        ),
      },
      {
        path: "onboarding/full",
        element: (
          <Suspense>
            <OnboardingFullPage />
          </Suspense>
        ),
      },
    ],
  },
];

export default sessionsRoutes;